

































































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";

@Component({
    components: {
        DateComponent: () => import("@/components/common/Inputs/Date.vue")
    }
})
export default class GrantInformation extends Vue {
    /**
        * Properties
     */
    @Prop() modelWrapper: any;
    @Prop() readonly: boolean;
    @Prop() data: any;

    /**
        * Declare variables
     */
    selectors: any  = [
        { "text": "Yes", "value": 1 },
        { "text": "No", "value": 0 }
    ];
    items: any = [];

    /**
        * Mounted function
     */
    mounted() {
        this.$services.grant.ActiveUsersByUserType()
        .then((resp: any) => {
            if (resp.Result == 'OK') {
                this.items = resp.Record;
            }
        })
    }
}
